import React from "react";
/** Components */
import { ObserverMobileDashboard } from "./Components/ObserverMobileDashboard";
import { ObserverOfflineChecklist } from "./Components/ObserverOfflineChecklist";
import { ObserverDashboardWeb } from "./Components/ObserverDashboardWeb";
/** Libs */
import { useParams } from "react-router-dom";

interface IProps {
  setFieldValue?: any;
  values?: any;
  editMode?: boolean;
}

export const DefaultBackGroundImage: React.FC<IProps> = ({
  setFieldValue,
  values,
  editMode,
}) => {
  const { brandId } = useParams();
  const viewMode = !!brandId && !editMode;
  return (
    <div className="grid grid-cols-4">
      {/* Observer Mobile Dashboard */}
      <ObserverMobileDashboard
        setFieldValue={setFieldValue}
        values={values}
        editMode={viewMode}
      />
      {/* Observer Offline Checklist */}
      <ObserverOfflineChecklist
        setFieldValue={setFieldValue}
        values={values}
        editMode={viewMode}
      />
      {/* Observer Dashboard Web */}
      <ObserverDashboardWeb
        setFieldValue={setFieldValue}
        values={values}
        editMode={viewMode}
      />
      {!viewMode && (
        <p className="mt-16 text-sm w-96 text-textMidLight dark:text-textMain">
          You can crop, resize, or edit your images at{" "}
          <a
            className="font-bold text-primary"
            href="https://www.iloveimg.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            iloveimg.com.
          </a>{" "}
        </p>
      )}
    </div>
  );
};
